<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Museum Abbreviations">
<p class="fm_h" id="sec3"><a href="#/text/Contents#rsec3"><span epub:type="pagebreak" id="page_xiii" title="xiii">Museum Abbreviations</span></a></p>
<table class="table">
<colgroup>
<col style="width:15%"/>
<col style="width:85%"/>
</colgroup>
<tbody><tr>
<td class="tdf"><p class="tabf">BSP</p></td>
<td class="tdf"><p class="tabf">Bayerische Staatssammlung für Paläontologie und Historische Geologie. Germany.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">BSPG</p></td>
<td class="tdf"><p class="tabf">Bayerische Staatssammlung für Paläontologie und Geologie. Germany</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">CGM</p></td>
<td class="tdf"><p class="tabf">Egyptian Geological Museum. Egypt.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">CMN</p></td>
<td class="tdf"><p class="tabf">Canadian Museum of Nature. Canada.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">FSAC-KK</p></td>
<td class="tdf"><p class="tabf">Faculte des Sciences Ain Chock, Universite Hassan II. Morocco.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">GZG</p></td>
<td class="tdf"><p class="tabf">Geo Wissenschaftliches Zentrum der Universität Göttingen. Germany.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">JP</p></td>
<td class="tdf"><p class="tabf">JuraPark. Poland.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">MDE</p></td>
<td class="tdf"><p class="tabf">Le Musée des Dinosaures Espéraza-Aude. France.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">MHNM</p></td>
<td class="tdf"><p class="tabf">Natural History Museum of Marrakech. Morocco.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">MN</p></td>
<td class="tdf"><p class="tabf">Museu Nacional, Rio de Janeiro. Brazil.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">MNUFRJ</p></td>
<td class="tdf"><p class="tabf">Museu Nacional of the Universidade Federal do Rio de Janeiro. Brazil.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">MPUR NS</p></td>
<td class="tdf"><p class="tabf">Museum of Paleontology, University of Rome. Italy.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">MSNM</p></td>
<td class="tdf"><p class="tabf">Museo Civico di Storia Naturale di Milano. Italy.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">OLPH</p></td>
<td class="tdf"><p class="tabf">Olphin collection of the Museo Geologico e Paleontologico. Italy</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">UALVP</p></td>
<td class="tdf"><p class="tabf">University of Alberta Laboratory for Vertebrate Paleontology. Canada.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">UCRC</p></td>
<td class="tdf"><p class="tabf">University of California. US.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">UCPC</p></td>
<td class="tdf"><p class="tabf">University of Connecticut. US.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">UMI</p></td>
<td class="tdf"><p class="tabf">University Moulay Ismail. Morocco.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">USNM</p></td>
<td class="tdf"><p class="tabf">National Museum of Natural History, Smithsonian Institution. US.</p></td>
</tr>
<tr>
<td class="tdf"><p class="tabf">ZIN</p></td>
<td class="tdf"><p class="tabf">Zoological Institute, Russian Academy of Sciences. Russia.<span epub:type="pagebreak" id="page_xiv" title="xiv"></span></p></td>
</tr>
</tbody></table>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter02.vue?17b49035